import ClusterToolTip from './component'

export default ClusterToolTip
